/**
 * Centralized logic for determining billing-related features.
 */

/**
 * Determines if an account is expected to have billing features.
 *
 * @param {object} accountDetails - The account details object.
 * @returns {boolean} - True if the account should have billing features, false otherwise.
 */
export const accountHasBilling = (accountDetails) => {
    if (!accountDetails) {
        return false;
    }

    // Accounts with channelId 0 (direct customers) and channelCode "PRIME" (Prime) have billing.
    // Other non-zero channelIds are for partners and do not have billing managed in this app.
    return accountDetails.channelId === 0 || accountDetails.channelCode === "PRIME";
};
